import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { peAccessForUser } from './peActions';

export default function PeGuard({ children }) {
  const { user, isLoaded } = useUser();
  if (!isLoaded) return <p role="status">Loading access…</p>;
  if (!peAccessForUser(user).allowed) return <section className="ni-panel"><h1>PE collaboration</h1><p role="alert">NI staff or an authorized GPV account is required. The API controls which actions are shared with you.</p></section>;
  return children;
}
